import {Component, OnInit} from '@angular/core';
import {UserVerificationService} from "../services/user-verification.service";
import { Subscription } from 'rxjs';
import {KeycloakService} from "../services/keycloak.service";

declare var $:any;

@Component({ standalone: false, 
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
})
export class LeftMenuComponent implements OnInit {

  public username =  KeycloakService.username;
  isAdmin: boolean = false;
  isAdminSubscription: Subscription;

  constructor(private userVerificationService: UserVerificationService){
    this.isAdmin = this.userVerificationService.isAdmin;
    this.userVerificationService.message.next(this.username);
  }

  ngOnInit() {
  }

  ngOnDestroy() {}
}
